{
  "运营管理": "Operations management",
  "企业与账号管理": "Enterprise and account management",
  "商家企业": "Merchant enterprises",
  "新建企业": "New enterprise",
  "企业": "Enterprise",
  "企业、标识、联系人或邮箱": "Enterprise, slug, contact or email",
  "企业名称": "Enterprise name",
  "企业标识": "Enterprise slug",
  "请输入企业标识": "Enter the enterprise slug",
  "国家或地区": "Country or region",
  "城市": "City",
  "合作身份": "Business role",
  "供应方": "Supplier",
  "买方": "Buyer",
  "买卖双方": "Buyer and supplier",
  "企业类型": "Enterprise type",
  "所属行业": "Industry",
  "企业官网": "Website",
  "请输入企业官网地址": "Enter the company website URL",
  "主营业务": "Main business",
  "企业所有者账号": "Enterprise owner account",
  "按姓名或邮箱搜索已有账号": "Find an existing account by name or email",
  "使用小写字母、数字和连字符": "Use lowercase letters, numbers and hyphens",
  "联系人": "Contact",
  "联系人姓名": "Contact name",
  "联系人职位": "Job title",
  "联系邮箱": "Contact email",
  "含国家区号，如 +86 13800138000": "Include the calling code, e.g. +86 13800138000",
  "认证材料": "Verification documents",
  "企业登记号": "Registration number",
  "注册地址": "Registered address",
  "资质材料链接": "Document URL",
  "认证材料必须是有效的 HTTPS 地址": "Enter a valid HTTPS document URL",
  "请输入有效的 HTTP 或 HTTPS 地址": "Enter a valid HTTP or HTTPS URL",
  "修改企业主体或资质材料后，买方和供应方认证需重新审核。": "Changes to company identity or documents require buyer and supplier verification again.",
  "内部备注": "Internal notes",
  "修改依据": "Reason for changes",
  "填写企业授权或资料变更依据": "Record company authorization or the reason for these changes",
  "创建企业": "Create enterprise",
  "编辑企业": "Edit enterprise",
  "企业资料已保存": "Enterprise details saved",
  "企业已创建": "Enterprise created",
  "后台录入": "Admin entry",
  "商家注册": "Merchant registration",
  "认证状态": "Verification status",
  "买方认证": "Buyer verification",
  "供应方认证": "Supplier verification",
  "未提交": "Not submitted",
  "待审核": "Pending review",
  "已通过": "Approved",
  "已驳回": "Rejected",
  "会员": "Membership",
  "免费会员": "Free",
  "基础会员": "Basic",
  "高级会员": "Premium",
  "已到期": "Expired",
  "长期有效": "No expiry",
  "企业详情": "Enterprise details",
  "企业资料": "Company profile",
  "成员数量": "Members",
  "查看资质材料": "View documents",
  "会员权益": "Membership",
  "企业状态": "Enterprise status",
  "停用企业": "Disable enterprise",
  "启用企业": "Enable enterprise",
  "提交审核": "Submit for review",
  "请先补齐企业登记号、注册地址和资质材料链接": "Add the registration number, registered address and document URL first",
  "认证已生效": "Verification is active",
  "调整会员": "Adjust membership",
  "提交{{direction}}认证": "Submit {{direction}} verification",
  "通过{{direction}}认证": "Approve {{direction}} verification",
  "驳回{{direction}}认证": "Reject {{direction}} verification",
  "会员等级": "Membership tier",
  "请选择会员等级": "Select a membership tier",
  "请选择到期时间": "Select an expiry date",
  "到期时间须晚于当前时间": "The expiry date must be in the future",
  "停用后，成员无法进入该企业空间，资料和操作记录保留。": "Members will lose access to this enterprise workspace. Its data and history are retained.",
  "操作依据": "Reason or authorization",
  "审核备注": "Review notes",
  "填写收款凭证或授权依据": "Record payment evidence or authorization",
  "填写操作原因或授权依据": "Record the reason or authorization",
  "请填写操作依据": "Enter the reason or authorization",
  "成员（{{count}}）": "Members ({{count}})",
  "认证记录": "Verification history",
  "会员流水": "Membership history",
  "操作记录": "Activity history",
  "企业角色": "Enterprise role",
  "已封禁": "Banned",
  "加入时间": "Joined at",
  "认证方向": "Verification type",
  "原状态": "Previous status",
  "原因或备注": "Reason or notes",
  "操作人": "Operator",
  "操作时间": "Time",
  "原会员等级": "Previous tier",
  "操作类型": "Action",
  "修改资料": "Profile updated",
  "变更状态": "Status changed",
  "驳回": "Reject",
  "企业注册证明": "Company registration document",
  "尚未上传认证材料": "No verification document uploaded",
  "认证资料加载失败": "Unable to load verification details",
  "当前认证状态": "Current verification status",
  "认证状态或材料已变化，请关闭后核对企业资料。": "The verification status or documents have changed. Close this dialog and check the company profile.",
  "审核材料": "Review document",
  "请先完善企业资料并上传认证材料": "Complete the company profile and upload a verification document first",
  "导出 CSV": "Export CSV",
  "导出当前筛选条件下的全部企业": "Export all enterprises matching the current filters",
  "企业与账号导出.csv": "enterprises-and-accounts.csv",
  "企业编号": "Enterprise ID",
  "联系电话": "Contact phone",
  "会员到期时间": "Membership expires at",
  "账号数量": "Account count",
  "最多导出 10000 条，请缩小筛选范围": "Export is limited to 10,000 records. Please narrow the filters."
}
